import {IntermediatePart} from "../../intermediatePart";

export default class CompleteVanity extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.partId = 'vanity';
    this.partName = 'Vanity';
    this.translateId = "visualizer.bathroom.vanity.vanity";
    this.homePageTitle = 'Complete Vanities';
    this.visible = true;
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new CompleteVanity());
  }

  setDefault(layout) {
    const availableCompleteFeatures = this.features.filter(feature => {
      return feature.metaData["Vanity"] && feature.metaData["Vanity"].includes("Complete")
    });
    const hardCodedDefault = this.features.find((feature) => {
      return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("Buffalo Complete Sand 987SANBLK17VK24");
    });
    // const placeholderDefault =
    //   (
    //     this.getParent().vanityCabinet
    //     && this.getParent().vanityCabinet.features
    //     && this.getParent().vanityCabinet.features.length
    //     && this.getParent().vanityCabinet.features.find((feature) => +feature.vanitySize === 24 && feature.dbFeature.displayName.includes("laceholder"))
    //   ) || this.features.find((feature) => {
    //     return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("Placeholder S");
    // });
    const placeholderDefault = this.features.find((feature) => {
      return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("Placeholder S");
    });
    // console.log('this.features', this.features);
    // console.log('placeholderDefault', placeholderDefault);
    this.activeFeature = hardCodedDefault || super.setDefault(layout) || availableCompleteFeatures[0];
    this.placeholderFeature = placeholderDefault || super.setDefault(layout) || null;
  }

  // setLayers(layout) {
  //   // const s3Binding = find(this.dbFeature.s3Bindings, {entityID: this.featureDefinitionId(this)});
  //     if (!this.activeFeature) {
  //         this.setDefault(layout);
  //     }
  //
  //   let s3Binding = find(this.activeFeature.dbFeature.s3Bindings, {
  //     entityID: this.getParent().featureDefinitionId(this),
  //     layout: layout.getCurrentLayoutAbbreviation()
  //   });
  //   if (!s3Binding) {
  //     s3Binding = find(this.activeFeature.dbFeature.s3Bindings, {entityID: this.featureDefinitionId(this)});
  //   }
  //   this.activeFeature.layer.fromS3Binding(s3Binding);
  // }

  setZIndex(zIndexes) {
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.Vanity.Complete.Cabinet;
      if (this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = zIndexes.Vanity.Complete.Cabinet;
      }
    }
  }
}
